// GENERATE BY ./scripts/generate.ts
// DO NOT EDIT IT MANUALLY
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import * as React from 'react';
import Icon from '../components/Icon';
var svg = function () { return (React.createElement("svg", { width: "32", height: "32", viewBox: "0 0 32 32", fill: "none", xmlns: "http://www.w3.org/2000/svg" },
    React.createElement("rect", { width: "32", height: "32", rx: "2", fill: "#FFE3BE" }),
    React.createElement("path", { d: "M23.5 17.125H8.5L7.375 16L8.875 14.5H23.125L24.625 16L23.5 17.125Z", fill: "#C87C1D" }),
    React.createElement("path", { d: "M22.375 24.625H9.625C9.21062 24.625 8.875 24.2894 8.875 23.875V8.125C8.875 7.71062 9.21062 7.375 9.625 7.375H18.625L23.125 11.875V23.875C23.125 24.2894 22.7894 24.625 22.375 24.625Z", fill: "white" }),
    React.createElement("path", { d: "M18.625 7.375V11.125C18.625 11.5394 18.9606 11.875 19.375 11.875H23.125L18.625 7.375Z", fill: "#D0D5DD" }),
    React.createElement("path", { d: "M23.875 22.75H8.125C7.71062 22.75 7.375 22.4144 7.375 22V16H24.625V22C24.625 22.4144 24.2894 22.75 23.875 22.75Z", fill: "#FBA943" }),
    React.createElement("path", { d: "M12.0483 17.7L12.646 18.7339H12.6715L13.2756 17.7H14.1609L13.1733 19.3364L14.1928 20.9727H13.2852L12.6715 19.9276H12.646L12.0323 20.9727H11.131L12.1458 19.3364L11.1566 17.7H12.0483Z", fill: "white" }),
    React.createElement("path", { d: "M14.57 17.7H15.5495L16.3805 19.7263H16.4189L17.2498 17.7H18.2294V20.9727H17.4592V18.9624H17.432L16.6458 20.952H16.1536L15.3674 18.9513H15.3402V20.9727H14.57V17.7Z", fill: "white" }),
    React.createElement("path", { d: "M18.7228 20.9727V17.7H19.5138V20.3303H20.8753V20.9727H18.7228Z", fill: "white" }))); };
var FileXmlIcon = function (props) { return (React.createElement(Icon, __assign({ component: svg }, props))); };
FileXmlIcon.displayName = 'FileXmlIcon';
/*
 *  temporary disable this rule for build
 */
// @ts-ignore
export default React.forwardRef(FileXmlIcon);
